Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var styles = _reactNative.StyleSheet.create({
    fullWidth: {
      maxWidth: _styles.STYLES.grid.maxInputWidth,
      width: '100%'
    }
  });
  return {
    styles: styles
  };
};